<template>
    <div>
        <div class="configurator__accordion-container"
             @click="toggleAccordion"
             :aria-expanded="isOpen"
             :aria-controls="`collapse-${category}`"
        >
            <h3 class="configurator__accordion-title">
                {{ category }}
            </h3>
            <span class="configurator__accordion-icon" :class="{'arrow-up': isOpen, 'arrow-down': !isOpen}"></span>
        </div>

        <ul class="configurator__specs-grid"
            v-show="isOpen"
            :id="`collapse-${category}`"
        >
            <li v-for="spec in specs" :key="spec.id">
                {{ spec.name }} — {{ spec.value }}
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    props: {
        category: {
            type: String,
            required: true,
        },
        specs: {
            type: [Object, Array],
            required: true
        },
        firstElement: {
            type: Boolean,
            required: true
        }
    },

    data() {
        return {
            isOpen: false
        }
    },

    mounted() {
        this.firstElement === true && (this.isOpen = true)
    },

    methods: {
        toggleAccordion: function () {
            this.isOpen = !this.isOpen
        }
    }
}
</script>

<style scoped lang="scss">
.configurator__accordion-container {
    width: 100%;
    border-radius: 10px;
    display: flex;
    justify-content: space-between;
    padding: 20px;
    box-shadow: 0 11px 24px rgba(0, 0, 0, 0.07);
    margin-top: 15px;
    cursor: pointer;

    .configurator__accordion-title {
        font-weight: 700;
        font-size: 16px;
        color: #243782;
    }

    .configurator__accordion-icon {
        content: url("/images/link-icon.svg");
        width: 22px;
        height: 22px;
    }

    .arrow-down {
        transform: rotate(270deg);
    }

    .arrow-up {
        transform: rotate(-270deg);
    }
}
</style>


// WEBPACK FOOTER //
// resources/assets/js/configurator/components/Accordion.vue